import { WalletSlice } from '../slice'
import { getEventTicketCodes } from './getEventTicketCodes'
import { getPastEvents } from './getPastEvents'
import { getPastGoodsServices } from './getPastGoodsServices'
import { getUpcomingEvents } from './getUpcomingEvents'
import { getUpcomingGoodsServices } from './getUpcomingGoodsServices'

export const WalletActions = {
  ...WalletSlice.actions,
  getPastEvents,
  getPastGoodsServices,
  getUpcomingEvents,
  getUpcomingGoodsServices,
  getEventTicketCodes,
}
